<template>
	<div class="page">
		<el-card>
			<div slot="header" class="card-header">
				<span>用户管理</span>
				<div style="float:right">
					<el-input v-model="keyword" placeholder="用户ID/用户名/昵称" style="width:220px" clearable
						@keyup.enter.native="search" @clear="search"></el-input>
					<el-button type="primary" icon="el-icon-search" @click="search" style="margin-left:8px">查询</el-button>
				</div>
			</div>
			<el-table :data="list" v-loading="loading" border stripe>
				<el-table-column prop="id" label="ID" width="90"></el-table-column>
				<el-table-column label="头像" width="70">
					<template slot-scope="scope">
						<el-image v-if="scope.row.headImage" :src="scope.row.headImage" style="width:36px;height:36px"
							fit="cover"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="userName" label="用户名" min-width="120"></el-table-column>
				<el-table-column prop="nickName" label="昵称" min-width="120"></el-table-column>
				<el-table-column label="类型" width="110">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.type === 0" type="danger">管理员</el-tag>
						<el-tag v-else-if="scope.row.type === 2" type="warning">审核账户</el-tag>
						<el-tag v-else>普通用户</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.isBanned ? 'info' : 'success'">
							{{ scope.row.isBanned ? '已封禁' : '正常' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createdTime" label="注册时间" min-width="160"></el-table-column>
			<el-table-column label="操作" width="340" fixed="right">
				<template slot-scope="scope">
					<el-button v-if="!scope.row.isBanned" size="mini" type="warning"
						@click="ban(scope.row)">封禁</el-button>
					<el-button v-else size="mini" type="success" @click="unban(scope.row)">解封</el-button>
					<el-button size="mini" @click="resetPwd(scope.row)">重置密码</el-button>
					<el-button size="mini" type="danger" plain @click="cleanMsg(scope.row)">清理记录</el-button>
					<el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
				</template>
			</el-table-column>
			</el-table>
			<el-pagination style="margin-top:16px" background layout="total, prev, pager, next"
				:total="total" :current-page="pageNo" :page-size="pageSize"
				@current-change="onPage"></el-pagination>
		</el-card>
	</div>
</template>

<script>
import AdminApi from '../../api/adminApi.js'

export default {
	data() {
		return {
			loading: false,
			list: [],
			total: 0,
			pageNo: 1,
			pageSize: 10,
			keyword: ''
		}
	},
	created() {
		this.load()
	},
	methods: {
		load() {
			this.loading = true
			new AdminApi().listUsers(this.pageNo, this.pageSize, this.keyword).then((page) => {
				this.list = page.records || []
				this.total = page.total || 0
			}).catch(() => {}).finally(() => {
				this.loading = false
			})
		},
		search() {
			this.pageNo = 1
			this.load()
		},
		onPage(p) {
			this.pageNo = p
			this.load()
		},
		ban(row) {
			this.$prompt('封禁原因', '封禁用户 ' + row.userName, {
				inputType: 'textarea',
				inputPlaceholder: '请输入封禁原因'
			}).then(({ value }) => {
				new AdminApi().banUser(row.id, value).then(() => {
					this.$message.success('已封禁')
					this.load()
				}).catch(() => {})
			}).catch(() => {})
		},
		unban(row) {
			new AdminApi().unbanUser(row.id).then(() => {
				this.$message.success('已解封')
				this.load()
			}).catch(() => {})
		},
		resetPwd(row) {
			this.$prompt('输入新密码', '重置密码 ' + row.userName, {
				inputType: 'password',
				inputPlaceholder: '新密码'
			}).then(({ value }) => {
				if (!value) return
				new AdminApi().resetPassword(row.id, value).then(() => {
					this.$message.success('密码已重置')
				}).catch(() => {})
			}).catch(() => {})
		},
		remove(row) {
			this.$confirm('确认删除用户 ' + row.userName + '？该操作不可恢复。', '警告', {
				type: 'warning'
			}).then(() => {
				new AdminApi().deleteUser(row.id).then(() => {
					this.$message.success('已删除')
					this.load()
				}).catch(() => {})
			}).catch(() => {})
		},
		cleanMsg(row) {
			this.$confirm('确认清理用户 ' + row.userName + ' 的全部私聊/群聊聊天记录？该操作不可恢复,仅清理消息不影响账号。', '清理聊天记录', {
				type: 'warning',
				confirmButtonText: '确认清理'
			}).then(() => {
				new AdminApi().cleanPrivate(row.id).then(() => {
					this.$message.success('聊天记录已清理')
				}).catch(() => {})
			}).catch(() => {})
		}
	}
}
</script>

<style scoped>
.page {
	padding: 4px;
}

.card-header {
	font-weight: 600;
}
</style>
